export const gridGapSize = 16;



// WEBPACK FOOTER //
// ./src/lib/styles/helpers.js